<template>
  <div
    class="relative w-full mx-auto"
    role="document"
  >
    <div
      class="bg-white rounded-lg shadow-2xl relative w-full h-full max-h-[calc(100vh-80px)] overflow-hidden"
    >
      <button
        class="p-0 absolute top-[-2px] right-[-44px] w-9 h-9 opacity-70 hover:opacity-100 transition"
        type="button"
        aria-label="Close"
        @click="closeModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
          class="w-full h-full"
        >
          <circle cx="17.5" cy="17.5" r="17.5" fill="#A3A3A3" />
          <path
            d="M17.5 0C7.84972 0 0 7.85167 0 17.5C0 27.1483 7.84972 35 17.5 35C27.1503 35 35 27.1483 35 17.5C35 7.85167 27.1503 0 17.5 0ZM17.5 32.5C9.99639 32.5 2.5 25.0056 2.5 17.5C2.5 9.99444 9.99639 2.5 17.5 2.5C25.0036 2.5 32.5 9.99444 32.5 17.5C32.5 25.0056 25.0036 32.5 17.5 32.5ZM18.8747 17.5L24.0197 12.355C24.202 12.1727 24.3044 11.9254 24.3044 11.6676C24.3044 11.4098 24.202 11.1626 24.0197 10.9803C23.8374 10.798 23.5902 10.6956 23.3324 10.6956C23.0746 10.6956 22.8273 10.798 22.645 10.9803L17.5 16.1253L12.355 10.9783C12.1716 10.8012 11.9261 10.7032 11.6711 10.7055C11.4162 10.7077 11.1724 10.8099 10.9921 10.9902C10.8119 11.1704 10.7096 11.4143 10.7074 11.6692C10.7052 11.9241 10.8032 12.1697 10.9803 12.3531L16.1253 17.5L10.9803 22.645C10.7977 22.8273 10.6951 23.0747 10.6949 23.3326C10.6947 23.5906 10.797 23.8381 10.9793 24.0207C11.1616 24.2033 11.409 24.3059 11.667 24.3061C11.9249 24.3063 12.1724 24.204 12.355 24.0217L17.5 18.8747L22.645 24.0197C22.7346 24.1127 22.8417 24.1869 22.9603 24.238C23.0788 24.2891 23.2063 24.3161 23.3354 24.3174C23.4645 24.3187 23.5926 24.2943 23.7121 24.2456C23.8317 24.1969 23.9403 24.1248 24.0317 24.0337C24.1231 23.9425 24.1955 23.8341 24.2445 23.7147C24.2936 23.5953 24.3184 23.4673 24.3174 23.3382C24.3165 23.2091 24.2899 23.0815 24.2391 22.9628C24.1883 22.8441 24.1144 22.7368 24.0217 22.6469L18.8747 17.5Z"
            fill="white"
          />
        </svg>
      </button>

      <div
            class="h-auto flex items-center px-4 py-3 4xl:!px-[36px] 4xl:!py-[24px] 5xl:!px-[42px] 5xl:!py-[30px] bg-gradient-to-r from-[#bcefdc] to-[#a1cde7] text-[#218863] 
            !text-[14px] 4xl:!text-[20px] 5xl:!text-[28px] font-medium rounded-t-xl pointer-events-none"
          >
        Connected Devices
      </div>

      <div class="p-8 h-full overflow-y-auto custom-scrollbar">
<div class="relative mb-6">
              <input
                type="text"
                placeholder="Search records"
                v-model="search"
                class="w-[215px] 4xl:w-[325px] 5xl:!w-[398px] h-auto pl-12 pr-3 py-2 4xl:!py-3 5xl:!py-5 5xl:!pl-18 5xl:!pr-7 border border-gray-300 
                rounded-md 4xl:rounded-[12px] text-gray-500 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#218863] 
                bg-white !text-[14px] 4xl:!text-[20px] 5xl:!text-[28px]"
                :disabled="loading"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5 4xl:w-6 4xl:h-6 5xl:w-9 5xl:h-9 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35m1.15-4.15a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>

        <div class="w-full">
          <div class="w-full relative">
            <div class="w-full">
              <EasyDataTable
                v-model:server-options="serverOptions"
                :items="items"
                :server-items-length="serverItemsLength"
                :loading="loading"
                :headers="Headers"
                :rows-items="rowItems"
                buttons-pagination
                table-class-name="customize-table"
                rows-per-page-message=""
                theme-color="#0492FF"
                show-index-symbol="No."
                show-index
              >
                <template #item-index="{ index }">
                  <div class="number">
                    {{ index }}
                  </div>
                </template>
                <template #header-DeviceType="header">
                  <div class="w-full flex justify-center">
                    {{ header.text }}
                  </div>
                </template>
                <template #header-Latitude="header">
                  <div class="w-full flex justify-center">
                    {{ header.text }}
                  </div>
                </template>
                <template #header-Longitude="header">
                  <div class="w-full flex justify-center">
                    {{ header.text }}
                  </div>
                </template>
                <template #header-FirmwareVersion="header">
                  <div class="w-full flex justify-center">
                    {{ header.text }}
                  </div>
                </template>
                <template #item-DeviceType="data">
                  <div class="w-full flex justify-center">
                    {{ data.DeviceType }}
                  </div>
                </template>
                <template #item-Latitude="data">
                  <div class="w-full flex justify-center">
                    {{ data.Latitude }}
                  </div>
                </template>
                <template #item-Longitude="data">
                  <div class="w-full flex justify-center">
                    {{ data.Longitude }}
                  </div>
                </template>
                <template #item-FirmwareVersion="data">
                  <div class="w-full flex justify-center">
                    {{ data.FirmwareVersion }}
                  </div>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mockServerItems } from "@/data/administrator/connectedDevicesTable";

export default {
  props: {
    datas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      temp: [], // Holds the complete, unfiltered original list
      items: [], // Holds the current page's sliced items (what is displayed)
      filteredData: [], // Holds the complete list of *filtered* items - NEW
      Headers: [
        {
          text: "Device Name",
          value: "DeviceName",
          sortable: false,
        },
        {
          text: "Device Type",
          value: "DeviceType",
          align: "center",
          sortable: false,
        },
        {
          text: "Latitude",
          value: "Latitude",
          align: "center",
          sortable: false,
        },
        {
          text: "Longitude",
          value: "Longitude",
          align: "center",
          sortable: false,
        },
        {
          text: "Firmware Ver.",
          value: "FirmwareVersion",
          align: "center",
          sortable: false,
        },
      ],
      isEdit: false,
      rowItems: [5, 10, 50, 100],

      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 5,
        sortBy: '',
        sortType: 'asc',
      },
      loading: false,
      formEdit: {},
    };
  },
  computed: {
    restApiUrl() {
      const { page, rowsPerPage, sortBy, sortType } = this.serverOptions;
      if (sortBy && sortType) {
        return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}&sortBy=${sortBy}&sortType=${sortType}`;
      } else {
        return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}`;
      }
    },
  },
  watch: {
    serverOptions: {
        handler() {
            // Re-run the load process whenever serverOptions changes (page/rows per page change)
            this.loadFromServer();
        },
        deep: true,
    },
    search: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
             // 1. Apply the filter to determine the new *total* set of items
             this.applyFilter();
             
             // 2. IMPORTANT: Reset to page 1 for a new search.
             if (this.serverOptions.page !== 1) {
                 // Change page, which triggers the serverOptions watcher and calls loadFromServer
                 this.serverOptions.page = 1; 
             } else {
                 // If already on page 1, manually call loadFromServer 
                 // because the serverOptions watcher won't fire.
                 this.loadFromServer();
             }
        }
      },
    },
    datas: {
      handler(newVal) {
        // Initialize all lists with the full dataset
        this.temp = newVal;
        this.filteredData = newVal;
        // Set the initial total length
        this.serverItemsLength = newVal.length;
        // Load the initial page
        this.loadFromServer();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    applyFilter() {
      const keyword = this.search.trim().toLowerCase();
      let sourceItems = this.temp;
      let filteredItems;

      if (!keyword) {
        filteredItems = sourceItems;
      } else {
        // Filter based on 'DeviceName'
        filteredItems = sourceItems.filter((item) => 
          item.DeviceName.toLowerCase().includes(keyword)
        );
      }

      // 1. Store the full list of filtered items
      this.filteredData = filteredItems;
      // 2. Update the total count for pagination controls
      this.serverItemsLength = filteredItems.length;
    },
    closeModal() {
      this.$emit("close-modal");
    },
    initializeModal() {
      // This is now handled in the 'datas' watcher
    },
    async loadFromServer() {
      this.hidePaginationIndex();
      this.loading = true;

      // Pass the *entire* currently filtered dataset (filteredData) to the mock server function for slicing
      const datasetToSlice = this.filteredData;

      // mockServerItems should slice the dataset based on serverOptions
      const { serverCurrentPageItems } = await mockServerItems(this.serverOptions, datasetToSlice);

      // Update the items displayed in the table with the current page's slice
      this.items = serverCurrentPageItems;
      
      this.loading = false;
    },
    hidePaginationIndex() {
      const paginationIndex = document.querySelectorAll(
        ".pagination__items-index"
      );
      const paginationRowInput = document.querySelector(".rows-input");
      if (!paginationIndex || !paginationRowInput) return;
      if (paginationIndex.length > 0) {
        paginationIndex.forEach((item) => {
          setTimeout(() => {
            item.innerHTML = "";
          }, 0);
        });
      }
      setTimeout(() => {
        paginationRowInput.innerHTML = "View";
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Only the deep selector for EasyDataTable remains, as Tailwind doesn't directly support deep selector modification */
:deep(.customize-table) {
  --easy-table-tbody-row: #f6f6f6 !important;
}
/* Note: You may need to add a custom scrollbar style here if 'custom-scrollbar' is not defined globally. */
</style>